/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Модель составного фильтра
   */
  app.Filters.CompoundFilter = app.Model.extend({
    data: {},
    viewClass: app.Filters.CompoundFilterView,
    initialize: function (data) {
      this.view = new this.viewClass({
        model: this,
        object: data.object,
        parent: this.get('element')
      });
      this.create(data.object.simpleSortSelected);
    },
    /**
     * Создает дочерние фильтры
     */
    create: function (simpleSortSelected) {
      var obj = this.get('object'),
        subFilters = {},
        element = $('#' + obj.name + '-list');
      if (obj && _.isObject(obj) && obj.sub_filters) {
        var data = obj.sub_filters;
        for (var i in data) {
          if (data.hasOwnProperty(i)) {
            data[i].title = data[i].name;
            data[i].name = i;
            var item = this.createItem(data[i].class_name, {
              element: element,
              object: data[i],
              parent: this
            });
            if (item) {
              subFilters[i] = item;
            }
          }
        }
        this.view.sortSelectedFilters(simpleSortSelected);
      }
      this.set('sub_filters', subFilters);
    },
    /**
     * Создает модель фильтра по его типу.
     * @param type Тип фильтра
     * @param data Данные фильтра
     * @returns {app.Model} Модель фильтра
     */
    createItem: function (type, data) {
      switch (type) {
        case 'CheckboxDropDown':
        case 'DropDown': {
          return new app.Filters.SelectFilter(data);
        }
        case 'Range':
        case 'AggRange': {
          return new app.Filters.RangeFilter(data);
        }
        case 'FastDelivery':
        case 'Checkbox': {
          data.object.selected = data.object.values.selected;
          return new app.Filters.CheckboxFilter(data);
        }
      }
      return false;
    },
    /**
     * Формирует объект параметров фильтрации
     * @param obj Исходный объект с параметрами
     * @returns {Object} Дополненный объект с параметрами фильтрации
     */
    toQuery: function (obj) {
      var subFilters = this.get('sub_filters');
      obj = obj || {};

      for (var i in subFilters) {
        if (subFilters.hasOwnProperty(i)) {
          var subFilter = subFilters[i];
          if (subFilter instanceof Backbone.Model) {
            obj = subFilter.toQuery(obj);
          }
        }
      }
      return obj;
    }
  });
})();

}.call(window));